// Angular
import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';
//State
import { UserContextState } from '../../../../auth/user-context.state';
import { Store } from '@ngxs/store';
// Services
import { RoleService } from '../../../../service/role.services';
import { BroadcastService } from '../../../../service/broadcast.service';
import { ModalService } from './../../../../service/modal.service';
// Model
import { AUTHACTIONS } from '../../../../model/role.model';
import { UserContextModel } from '../../../../auth/user-context.model';
import { AppService } from 'libs/core/src/lib/service/app.service';
import { BroadcastEventModel } from 'libs/core/src/lib/model/broadcast-event.model';

@Component({
	selector: 'cv-pwa-header',
	templateUrl: './pwa-header.component.html',
	styleUrls: ['./pwa-header.component.scss'],
})
export class PWAHeaderComponent implements OnInit {
	user$: Observable<any> = this.store.select(UserContextState.getUserContext);
	@Input() toggleUser: boolean;
	@Input() profile: Observable<any>;

	public user;
	public openSubItems = false;
	public isBorrower = false;

	private atComponentDestroy = new Subject();

	get isSMSEnabled(): any {
		return this.appService.isSMSEnabled(this.store);
	}

	constructor(
		private store: Store,
		private roleService: RoleService,
		private broadcastService: BroadcastService,
		private modalService: ModalService,
		private appService: AppService,
	) {
	}

	ngOnInit(): void {
		this.user$.pipe(
			take(1),
			tap((user: UserContextModel) => {
				if (user && user.role) {
					this.user = user;
				}
			})
		).subscribe();

		this.broadcastService.onEvent('ACTIVATE_BORROWER_PROFILE')
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: BroadcastEventModel) => {
				const data = event.event;
				this.isBorrower = data.isBorrower;
			});
	}

	/**
	 * Broadcast to open the User View
	 */
	public openUserView(): void {

		this.openSubItems = false;

		this.broadcastService.broadcast({
			name: 'OPEN_PROFILE_DIALOG',
			event: {}
		});
	}

	/**
	 * Broadcast to Vendor Exp App to open the Profile view
	 * Only available on Mobile
	 */
	public openProfileView(): void {
		this.openSubItems = false;
		this.broadcastService.broadcast({
			name: 'OPEN_PROFILE_SETTINGS_DIALOG',
			event: {}
		});
	}

	/**
	 * Logout user.
	 */
	public logout(): void {
		this.modalService.customConfirm(
			'Logout',
			`Are you sure?`,
			'fal fa-sign-out-alt',
			'Log out',
			'cv-btn-link-error'
		).subscribe(async result => {
			if(result.confirm === 'confirm'){
				this.roleService.unAuthSetValues(AUTHACTIONS.LOGOUT);
			}
		});
	}

	/**
	 * Open settings dialog
	 */
	public openSMSSettingsView() {
		this.openSubItems = false;

		this.broadcastService.broadcast({
			name: 'OPEN_SETTINGS_DIALOG',
			event: {}
		});
	}
}

